import apiClient from "./apiService";
import {parseFiltersToQueryString} from "../utils/parseFiltersToQueryString";

class RejectedPromoterService {
    async getAll(filters = {}) {
        const queryString = parseFiltersToQueryString(filters);
        const response = await apiClient.get(`/rejected-promoters?${queryString}`);
        return response.data;
    }

    async getAllWithPagination(filters = {}, page = 1, limit = 10) {
        try {
            const queryString = parseFiltersToQueryString(filters);
            const params = new URLSearchParams(queryString);
            params.append("page", page);
            params.append("size", limit);
            const response = await apiClient.get(`/rejected-promoters?${params.toString()}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    static getInstance() {
        if (!RejectedPromoterService.instance) {
            RejectedPromoterService.instance = new RejectedPromoterService();
        }
        return RejectedPromoterService.instance;
    }
}

export default RejectedPromoterService.getInstance();
